import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./services/i18n";
import App from './App';
import reportWebVitals from './reportWebVitals';
import SnackBarProvider from './sharedComponent/UI/Snackbar';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

// if (process.env.NODE_ENV != 'production') {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('https://app-uat.hdor.com/service-worker.js')
//       .then(() => console.log('Service Worker registered'))
//       .catch((error) => console.error('Service Worker registration failed:', error));
//   }
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <SnackBarProvider>
    <App />
  </SnackBarProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
